import { Helmet } from 'react-helmet-async'
import { useDarkMode } from '../providers/DarkModeProvider'
import { useUserState } from '../providers/UserProvider'

export function HtmlHeader() {
  const user = useUserState()
  const isDarkMode = useDarkMode()

  // Set theme color based on dark mode preference
  const themeColor = isDarkMode ? '#1f1f1f' : '#ffffff'

  return (
    <Helmet>
      <title>{user ? 'NotePlan for Web' : 'NotePlan Login'}</title>
      <meta name='robots' content='noindex, nofollow' />
      <meta name='theme-color' content={themeColor} />
      <link rel='canonical' href={window.location.href} />
      <link
        rel='stylesheet'
        href={`/${isDarkMode ? 'atom-one-dark' : 'xcode'}.css`}
      />
    </Helmet>
  )
}
